import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { editWriteOffctItemPassportNumberAPI } from '../../../../../api/writeOff/writeOffActItemAPI'
import TextFieldMain from '../../../../form/fields/TextFieldMain'

const ChangePassportNumberForm = ({ writeOffActItemBd, setOpen }) => {

	const dispatch = useDispatch()

    const [data, setData] = useState(
        writeOffActItemBd ? 
            {
                passportNumber: writeOffActItemBd.passportNumber,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editWriteOffctItemPassportNumberAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: writeOffActItemBd.id,
            passportNumber: data.passportNumber,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('passportNumber', 'writeOffActItem') ?
				<TextFieldMain
					required={formDataProductRequiredField('passportNumber', 'writeOffActItem')}
					setValidate={e => updateValidate(setValid, 'passportNumber', e)}
					setValueForm={e => setValueForm(setData, 'passportNumber', e)}
					forciblyValue={data && data.passportNumber ? data.passportNumber : ''}
                    label='Номер паспорта'
                    // placeholder='Введіть дату'
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangePassportNumberForm